import defaultMetrics from '@/organisms/plans/utils/defaultMetrics';
import ActionType from '@/shared/enums/ActionType';
import EntityType from '@/shared/enums/EntityType';
import entityLabel from '@/shared/utils/entityLabel';
import defaultMetricGroup from '@pkg/entities/snapshots/utils/defaultMetricGroup';

export default function updatedFTEAction({
  actionMap,
  actionType = ActionType.UPDATE_FTE,
  comparisonScenario,
  role,
  scenario,
}) {
  const originalRole = comparisonScenario.relationships
    .get(EntityType.ROLE)
    ?.get(role.uuid);
  const group = role
    ? scenario?.relationships.get(EntityType.GROUP)?.get(role.group_uuid)
    : null;

  const metrics = {
    ...role.__metrics.self.visible,
  };

  const existingAction = actionMap?.get(actionType);

  const action = existingAction ?? {
    entity: EntityType.ROLE,
    impact: defaultMetricGroup(),
    metrics: defaultMetrics({ comparisonScenario }),
    type: actionType,
    [EntityType.ROLE]: new Map(),
    [EntityType.GROUP]: new Set(),
  };

  if (group) {
    action[EntityType.GROUP].add(group.uuid);
  }

  const fteChange = metrics.fte - originalRole.__metrics.self.visible.fte;
  const allocatedFTEChange =
    metrics.allocatedFTE - originalRole.__metrics.self.visible.allocatedFTE;
  action.metrics[1].allocatedFTE += allocatedFTEChange;
  action.metrics[1].fte += fteChange;

  // Impact changes.
  action.impact.allocatedFTE += allocatedFTEChange;
  action.impact.fte += fteChange;

  // Aggregate the individual role action metrics.
  const actionRole = action[EntityType.ROLE].get(role.uuid) ?? {
    impact: defaultMetricGroup(),
    metrics: defaultMetrics({ comparisonScenario, role }),
  };
  actionRole.metrics[1].allocatedFTE += allocatedFTEChange;
  actionRole.metrics[1].fte += fteChange;
  action[EntityType.ROLE].set(role.uuid, actionRole);

  // Individual role impact changes.
  actionRole.impact.allocatedFTE = allocatedFTEChange;
  actionRole.impact.fte = fteChange;

  const roleCount = action[EntityType.ROLE].size;
  const roleLabel = entityLabel(EntityType.ROLE, roleCount !== 1);

  action.title = `FTE was updated for ${roleCount} ${roleLabel}`;

  return action;
}
